var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Button, Divider, Stack, Typography, useMediaQuery } from '@mui/material';
import { t } from 'i18next';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Config } from '../../api/config';
import { assigntoFinalInspectorUrl, getFinalInspectorListUrl, getFIObservationData, jobCardGetDetailAPI } from '../../api/url';
import { MuiSelectComponent } from '../../components/atoms/muiSelectComponent';
import SkeletonLoader from '../../components/atoms/sketeton';
import { MuiStack } from '../../components/atoms/stackComponent';
import { MuiPopup } from '../../components/molecules/popupComponent';
import { isModuleConfig, Module } from '../../constants';
import { showLoader, showNotification } from '../../redux/commonSlice';
import { getByIdAPI, getListAPI, setState, updateAPI } from '../../redux/crudSlice';
import { useAppSelector } from '../../store/hooks';
import useAnalyticsEventTracker from '../../utils/useAnalyticsEventTracker';
import { FIMenuFeatures, JCMenuFeatures } from './services/jcEntity';
import React from 'react';
export var AssignFinalInspectorPopup = function (_ref) {
    var _jobCardData$FinalIns, _FIObservation$data3;
    var isOpen = _ref.isOpen, data = _ref.data, jobCardData = _ref.jobCardData, assignValue = _ref.assignValue, onClose = _ref.onClose;
    var trackButtonClick = useAnalyticsEventTracker("AssignFinalInspectorPopup");
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var id = useParams().id;
    var _a = useState(''), selectedFinalInspector = _a[0], setSelectedFinalInspector = _a[1];
    var _b = useState([]), finalInspectorList = _b[0], setFinalInspectorList = _b[1];
    var _c = useState([]), finalInspectorListWithoutAssigned = _c[0], setFinalInspectorListWithoutAssigned = _c[1];
    var _d = useState(null), assignedFinalInspector = _d[0], setAssignedFinalInspector = _d[1];
    var _e = useState([]), fiObervationDetails = _e[0], setFIObservationDetails = _e[1];
    var _f = useState(true), fiObervationSkeleton = _f[0], setFiObervationSkeleton = _f[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var FIObservation = useAppSelector(function (state) { return state.crud; }).FIObservation;
    var dispatch = useDispatch();
    useEffect(function () {
        initialDataFunction();
    }, []);
    useEffect(function () {
        if (jobCardData !== null && jobCardData !== void 0 && jobCardData.OrganizationId && FIObservation !== null && FIObservation !== void 0 && FIObservation.data) {
            dispatch(showLoader({
                isLoaderOpen: true
            }));
            getFinalInspectorList(jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.OrganizationId);
        }
    }, [FIObservation === null || FIObservation === void 0 ? void 0 : FIObservation.data]);
    var initialDataFunction = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(jobCardData !== null && jobCardData !== void 0 && jobCardData.JobCardId)) return [3 /*break*/, 2];
                    return [4 /*yield*/, getFIObservation(jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.JobCardId)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var getFIObservation = function (jobCardId) { return __awaiter(void 0, void 0, void 0, function () {
        var _FIObservationResult$, _FIObservationResult$2, payload, FIObservationResult, _FIObservationResult$3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(showLoader({
                        isLoaderOpen: true
                    }))];
                case 1:
                    _a.sent();
                    payload = {
                        JobCardId: jobCardId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "FIObservation",
                            url: getFIObservationData,
                            request: payload
                        }))];
                case 2:
                    FIObservationResult = _a.sent();
                    if (!(FIObservationResult !== null && FIObservationResult !== void 0 && (_FIObservationResult$ = FIObservationResult.payload) !== null && _FIObservationResult$ !== void 0 && (_FIObservationResult$ = _FIObservationResult$.value) !== null && _FIObservationResult$ !== void 0 && _FIObservationResult$.data && FIObservationResult !== null && FIObservationResult !== void 0 && (_FIObservationResult$2 = FIObservationResult.payload) !== null && _FIObservationResult$2 !== void 0 && (_FIObservationResult$2 = _FIObservationResult$2.value) !== null && _FIObservationResult$2 !== void 0 && _FIObservationResult$2.success)) return [3 /*break*/, 4];
                    setFIObservationDetails(FIObservationResult === null || FIObservationResult === void 0 || (_FIObservationResult$3 = FIObservationResult.payload) === null || _FIObservationResult$3 === void 0 || (_FIObservationResult$3 = _FIObservationResult$3.value) === null || _FIObservationResult$3 === void 0 ? void 0 : _FIObservationResult$3.data);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getFinalInspectorList = function (branchId) { return __awaiter(void 0, void 0, void 0, function () {
        var _finalInspectorListRe, _finalInspectorListRe2, request, finalInspectorListResult, _finalInspectorListRe3, _FIObservation$data, data_1, finalInspectorList_1, assignedFI, filteredList, _FIObservation$data2, FIObervationID_1, assignedFI, filteredList, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: true
                        }))];
                case 1:
                    _a.sent();
                    request = {
                        // OrganizationId: '66659225-96eb-4e12-9719-360e47ea3280'
                        WorkingOrganizationId: branchId
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: "finalInspectorList",
                            url: getFinalInspectorListUrl,
                            request: request
                        }))];
                case 2:
                    finalInspectorListResult = _a.sent();
                    if (!((finalInspectorListResult === null || finalInspectorListResult === void 0 || (_finalInspectorListRe = finalInspectorListResult.payload) === null || _finalInspectorListRe === void 0 || (_finalInspectorListRe = _finalInspectorListRe.value) === null || _finalInspectorListRe === void 0 ? void 0 : _finalInspectorListRe.statusCode) == 200 || finalInspectorListResult !== null && finalInspectorListResult !== void 0 && (_finalInspectorListRe2 = finalInspectorListResult.payload) !== null && _finalInspectorListRe2 !== void 0 && (_finalInspectorListRe2 = _finalInspectorListRe2.value) !== null && _finalInspectorListRe2 !== void 0 && _finalInspectorListRe2.success)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(showLoader({
                            isLoaderOpen: false
                        }))];
                case 3:
                    _a.sent();
                    data_1 = finalInspectorListResult === null || finalInspectorListResult === void 0 || (_finalInspectorListRe3 = finalInspectorListResult.payload) === null || _finalInspectorListRe3 === void 0 || (_finalInspectorListRe3 = _finalInspectorListRe3.value) === null || _finalInspectorListRe3 === void 0 ? void 0 : _finalInspectorListRe3.data;
                    finalInspectorList_1 = data_1.map(function (element) {
                        return _objectSpread(_objectSpread({}, element), {}, {
                            name: "".concat(element !== null && element !== void 0 && element.FirstName ? element === null || element === void 0 ? void 0 : element.FirstName : '-', " ").concat(element !== null && element !== void 0 && element.LastName ? element === null || element === void 0 ? void 0 : element.LastName : ""),
                            assignId: element !== null && element !== void 0 && element.IdentityId ? element === null || element === void 0 ? void 0 : element.IdentityId : element === null || element === void 0 ? void 0 : element.EmployeeId
                        });
                    });
                    setFinalInspectorList(finalInspectorList_1);
                    if (jobCardData !== null && jobCardData !== void 0 && jobCardData.FinalInspectorId) {
                        assignedFI = finalInspectorList_1.filter(function (item, index) { return item.assignId === (jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.FinalInspectorId); });
                        filteredList = finalInspectorList_1.filter(function (item, index) { return item.assignId != (jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.FinalInspectorId); });
                        setAssignedFinalInspector(assignedFI);
                        setFinalInspectorListWithoutAssigned(filteredList);
                    }
                    else if (FIObservation !== null && FIObservation !== void 0 && (_FIObservation$data = FIObservation.data) !== null && _FIObservation$data !== void 0 && _FIObservation$data.FinalInspectorId) {
                        FIObervationID_1 = FIObservation === null || FIObservation === void 0 || (_FIObservation$data2 = FIObservation.data) === null || _FIObservation$data2 === void 0 ? void 0 : _FIObservation$data2.FinalInspectorId;
                        assignedFI = finalInspectorList_1.filter(function (item, index) { return item.assignId === FIObervationID_1; });
                        filteredList = finalInspectorList_1.filter(function (item, index) { return item.assignId != FIObervationID_1; });
                        setAssignedFinalInspector(assignedFI);
                        setFinalInspectorListWithoutAssigned(filteredList);
                    }
                    else {
                        setFinalInspectorListWithoutAssigned(finalInspectorList_1);
                    }
                    setFiObervationSkeleton(false);
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_1 = _a.sent();
                    console.error("Error fetching vehicle types:", error_1);
                    return [2 /*return*/, []];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onSaveClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, _response$payload2, imagePayload_1, payload, response, changeStatusResponse, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "Reassign_FI", undefined);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    imagePayload_1 = [];
                    if (fiObervationDetails !== null && fiObervationDetails !== void 0 && fiObervationDetails.ImageAttachments) {
                        fiObervationDetails === null || fiObervationDetails === void 0 || fiObervationDetails.ImageAttachments.map(function (imageItem) {
                            if (imageItem.AttachmentId) {
                                imagePayload_1.push({
                                    "AttachmentId": imageItem.AttachmentId,
                                    "MediaType": imageItem.MediaType,
                                    "SystemName": "AssigntoFinalInspector"
                                });
                            }
                        });
                    }
                    payload = {
                        "JobCardId": jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.JobCardId,
                        "FinalInspectorId": selectedFinalInspector,
                        // employee id from get list
                        "ImageAttachments": imagePayload_1 !== null && imagePayload_1 !== void 0 ? imagePayload_1 : [],
                        "JobCardNo": jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.JobCardNo
                    };
                    if (fiObervationDetails.Observation) {
                        payload.Observation = fiObervationDetails.Observation;
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: '',
                            url: assigntoFinalInspectorUrl,
                            request: payload
                        }))];
                case 2:
                    response = _a.sent();
                    if (!(response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) === 200)) return [3 /*break*/, 6];
                    if (!(assignValue == JCMenuFeatures.AssignFinalInspector)) return [3 /*break*/, 4];
                    return [4 /*yield*/, dispatch(updateAPI({
                            key: '',
                            url: "".concat(Config.baseURL, "JobCard/").concat(jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.JobCardId, "/FinalInspectionJobCard")
                        }))];
                case 3:
                    changeStatusResponse = _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: 'documentDetailsGetById',
                        url: jobCardGetDetailAPI(jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.JobCardId),
                        request: {}
                    }))];
                case 5:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    onClose();
                    dispatch(setState({
                        key: "menuValue",
                        value: assignValue
                    }));
                    dispatch(showNotification({
                        isOpen: true,
                        message: assignValue == JCMenuFeatures.AssignFinalInspector ? "Final inspector assigned successfully" : "Final inspector reassigned successfully",
                        type: "success"
                    }));
                    _a.label = 6;
                case 6:
                    // buttonClickSpan.end();
                    // pageLoadSpan.end();
                    // transaction.end();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    return [3 /*break*/, 8];
                case 7:
                    e_1 = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    console.log("error", e_1);
                    return [3 /*break*/, 8];
                case 8:
                    onClose();
                    return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        showLoaderOnPopup: true,
        openPopup: isOpen,
        title: assignValue == JCMenuFeatures.AssignFinalInspector ? t('Assign final inspector') : t('RASSIGN_FINAL_INSPECTOR'),
        subTitle: t("Job card no: ") + "".concat(Module === isModuleConfig.Bajaj ? jobCardData !== null && jobCardData !== void 0 && jobCardData.SourceDocumentNo ? jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.SourceDocumentNo : "" : "".concat(jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.Code).concat(jobCardData !== null && jobCardData !== void 0 && jobCardData.SourceDocumentNo ? " / ".concat(jobCardData === null || jobCardData === void 0 ? void 0 : jobCardData.SourceDocumentNo) : "")),
        onClose: onClose,
        variant: "h1"
        // width={40}
        // height={50}
        ,
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: '5px'
        },
        containerStyle: {
            "&.MuiDialogContent-root": {
                width: lgMode ? '500px' : 'calc(90vw)',
                padding: 2
            }
        }
    }, /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(MuiStack, {
        sx: {
            marginTop: '10px'
        },
        direction: 'column',
        paddingBottom: "5px"
    }, loader !== null && loader !== void 0 && loader.isLoaderOpen ? /*#__PURE__*/ React.createElement(MuiStack, {
        height: '40px',
        marginY: 1,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)) : /*#__PURE__*/ React.createElement(React.Fragment, null, assignValue == JCMenuFeatures.AssignFinalInspector ? /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        py: 1,
        gap: 1
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h3",
        style: {
            marginLeft: '5px'
        }
    }, t('Final inspector')), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        caption: "Final inspector",
        fullWidth: true,
        options: finalInspectorList || [],
        displayExpr: "name",
        valueExpr: "assignId",
        name: "finalInspector",
        value: selectedFinalInspector !== null && selectedFinalInspector !== void 0 ? selectedFinalInspector : '',
        onChange: function (event) {
            var _event$target$value, _event$target;
            console.log("eventeventevent", event === null || event === void 0 ? void 0 : event.target);
            setSelectedFinalInspector((_event$target$value = event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "");
        }
    })) : /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        py: 1,
        gap: 1
    }, !fiObervationSkeleton && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "medium",
        color: "secondary"
    }, t('From FI')), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        id: "finalinspection",
        fullWidth: true,
        size: "small",
        value: (_jobCardData$FinalIns = jobCardData.FinalInspectorId) !== null && _jobCardData$FinalIns !== void 0 ? _jobCardData$FinalIns : FIObservation === null || FIObservation === void 0 || (_FIObservation$data3 = FIObservation.data) === null || _FIObservation$data3 === void 0 ? void 0 : _FIObservation$data3.FinalInspectorId,
        displayExpr: "name",
        valueExpr: "assignId",
        disabled: true,
        options: finalInspectorList || []
    }), /*#__PURE__*/ React.createElement(Typography, {
        fontSize: "sm",
        fontWeight: "medium",
        color: "secondary",
        mt: 1.5
    }, t('To FI')), /*#__PURE__*/ React.createElement(MuiSelectComponent, {
        displayConcat: true,
        caption: "Final Inspector",
        fullWidth: true,
        options: finalInspectorListWithoutAssigned || [],
        displayExpr: "name",
        valueExpr: "assignId",
        name: "finalinspector",
        value: selectedFinalInspector !== null && selectedFinalInspector !== void 0 ? selectedFinalInspector : '',
        onChange: function (event) {
            var _event$target$value2, _event$target2;
            setSelectedFinalInspector((_event$target$value2 = event === null || event === void 0 || (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "");
        }
    })))), fiObervationSkeleton && (assignValue == JCMenuFeatures.ReassignFinalInspector || assignValue == FIMenuFeatures.ReassignFinalInspector) && /*#__PURE__*/ React.createElement(MuiStack, {
        height: '40px',
        marginY: 1,
        paddingX: 1,
        width: '100%'
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), /*#__PURE__*/ React.createElement(Stack, {
        py: 2,
        gap: '16px'
    }, /*#__PURE__*/ React.createElement(Button, {
        id: "saveButton",
        children: t("Save"),
        color: "primary",
        variant: "contained",
        size: "medium",
        disabled: !selectedFinalInspector,
        onClick: function () { return onSaveClick(); }
    }), /*#__PURE__*/ React.createElement(Button, {
        id: "cancelButton",
        children: t("Cancel"),
        variant: "outlined",
        size: "medium",
        color: "secondary",
        onClick: function () { return onClose(); }
    }))));
};
export default AssignFinalInspectorPopup;
